import { ThrowStmt } from '@angular/compiler';

export class AlternativeSearchesAvailable {
    public CompanyNameResultCount: number;
    public CompanyPhoneResultCount: number;
    public IdResultCount: number;
    public FullNameResultCount: number;
    public ProductCategoryResultCount: number;
    public BrandNamesResultCount: number;
    public CompanyDescriptionResultCount: number;
    public CompanyCityResultCount: number;
    public CompanyStateResultCount: number;
    public CompanyCountryResultCount: number;
    public WebsiteResultCount: number;
    public CompanyEmailResultCount: number;
    public IndividualEmailResultCount: number;
    public IndividualPhoneResultCount: number;
    public ZipResultCount: number;
    constructor(
        CompanyNameResultCount: number,
        IdResultCount: number,
        FullNameResultCount: number,
        ProductCategoryResultCount: number,
        BrandNamesResultCount: number,
        CompanyDescriptionResultCount: number,
        CompanyCityResultCount: number,
        CompanyStateResultCount: number,
        CompanyCountryResultCount: number,
        WebsiteResultCount: number,
        CompanyEmailResultCount: number,
        IndividualEmailResultCount: number,
        ZipResultCount: number,
        CompanyPhoneResultCount: number,
        IndividualPhoneResultCount: number
    ) {
        this.CompanyNameResultCount = CompanyNameResultCount;
        this.IdResultCount = IdResultCount;
        this.FullNameResultCount = FullNameResultCount;
        this.ProductCategoryResultCount = ProductCategoryResultCount;
        this.BrandNamesResultCount = BrandNamesResultCount;
        this.CompanyDescriptionResultCount = CompanyDescriptionResultCount;
        this.CompanyCityResultCount = CompanyCityResultCount;
        this.CompanyStateResultCount = CompanyStateResultCount;
        this.CompanyCountryResultCount = CompanyCountryResultCount;
        this.WebsiteResultCount = WebsiteResultCount;
        this.CompanyEmailResultCount = CompanyEmailResultCount;
        this.IndividualEmailResultCount = IndividualEmailResultCount;
        this.ZipResultCount = ZipResultCount;
        this.CompanyPhoneResultCount = CompanyPhoneResultCount;
        this.IndividualPhoneResultCount = IndividualPhoneResultCount;
    }
    getCount(): number {
        var count: number = 0;
        if (this.CompanyNameResultCount > 0) count++;
        if (this.IdResultCount > 0) count++;
        if (this.FullNameResultCount > 0) count++;
        if (this.ProductCategoryResultCount > 0) count++;
        if (this.BrandNamesResultCount > 0) count++;
        if (this.CompanyDescriptionResultCount > 0) count++;
        if (this.CompanyCityResultCount > 0) count++;
        if (this.CompanyStateResultCount > 0) count++;
        if (this.CompanyCountryResultCount > 0) count++;
        if (this.WebsiteResultCount > 0) count++;
        if (this.CompanyEmailResultCount > 0) count++;
        if (this.IndividualEmailResultCount > 0) count++;
        if (this.ZipResultCount > 0) count++;
        if (this.CompanyPhoneResultCount > 0) count++;
        if (this.IndividualPhoneResultCount > 0) count++;
        return count;
    }
}